import { render, staticRenderFns } from "./buildingBag.vue?vue&type=template&id=4183c5c0&scoped=true&"
import script from "./buildingBag.vue?vue&type=script&lang=js&"
export * from "./buildingBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4183c5c0",
  null
  
)

export default component.exports